import React from 'react';
import { modelClass } from '/imports/api/cardNames';
import { ModelFormPage } from '/imports/ui/ModelFormPage';

export const CardNamePage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [[{ field: 'name', label: 'Name' }]]}
  />
);
